import React from 'react'
import SAISVG from '../../../../../../_template/helpers/CommonFunction'
import { getShortForm,timeZoneDateFormat } from '../../../../../component/common/Helper'
const ContactRequestList = (props) => {
    const {
        contactRequest,
    } = props;
    const contactRequestDeleteOnClick = () => {
        props.contactRequestDelete(contactRequest.id)
    }
    return (
        <>
            <tr className="">
                <td className="d-flex align-items-center border-none">
                    <div className="symbol rounded symbol-50px overflow-hidden me-3">
                        <a>
                            <div className="symbol-label fs-3 bg-light-dark text-dark fw-bold text-uppercase">
                                {getShortForm(contactRequest.name)}
                            </div>
                        </a>
                    </div>
                    <div className="d-flex flex-column">
                        <a className="text-gray-800  mb-1">
                            {contactRequest.name}
                        </a>
                        <span>
                            <div className="badge badge-light-dark fw-bold">
                                {contactRequest.email}
                            </div>
                        </span>
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {contactRequest.phone_no}
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {contactRequest.organization}
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {contactRequest.designation}
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {contactRequest.select_works}
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {contactRequest.comments}
                    </div>
                </td>
                <td>
                    <div className="fw-bolder text-gray-700">
                        {timeZoneDateFormat(contactRequest.created_at)}
                    </div>
                </td>
                <td>
                    <button 
                        className="btn btn-sm btn-icon btn-light-danger px-4"
                        onClick={contactRequestDeleteOnClick}
                    >
                        <SAISVG path="media/icons/duotune/general/gen027.svg" className="svg-icon-muted svg-icon-2" />
                    </button>
                </td>
            </tr>
        </>
    )
}

export default ContactRequestList